import { TableCustom } from '../../../../../../component/table/table-custom/TableCustom';
import { VERIFY_HISTORY_COLUMNS } from '../Columns';

const CheckHistory = ({ data }: { data: any[] }) => {
	return <TableCustom data={data} columns={VERIFY_HISTORY_COLUMNS} maxHeight={200} />;
};

export default CheckHistory;
